// Meeting.js
import React from "react";


const meetings = [
  {
    title: "Sunday Worship Service",
    day: "Sunday",
    time: "8:00 AM - 10:00 AM",
    image: "/images/meeting1.jpg",
    description: "Join us every Sunday for uplifting worship and teaching."
  },
  {
    title: "Midweek Bible Study",
    day: "Wednesday",
    time: "6:00 PM - 7:30 PM",
    image: "/images/meeting2.jpg",
    description: "Deepen your understanding of God's word with our Bible study sessions."
  }
];

const Meeting = () => {
  return (
    <div className="container py-5">
      <h2 className="text-center mb-5">Meetings</h2>
      <div className="row g-4">
        {meetings.map((meeting, index) => (
          <div className="col-md-6" key={index}>
            <div className="card shadow-sm h-100">
              <img
                src={meeting.image}
                className="card-img-top"
                alt={meeting.title}
                style={{ height: "250px", objectFit: "cover" }}
              />
              <div className="card-body" style={{ backgroundColor: "#E8F0FE" }}>
                <h5 className="card-title">{meeting.title}</h5>
                <p><strong>Day:</strong> {meeting.day}</p>
                <p><strong>Time:</strong> {meeting.time}</p>
                <p>{meeting.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Meeting;
